<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-product-sidebar ref="productSidebar" />
    <popup-add-venue ref="popupAddVenue" />

    <div class="flex justify-between">
      <p>
        These are venues assigned to REKOM POS. Here you can add a new venue and
        edit a venues' locations, storages and terminals.
      </p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupAddVenue.show(accountId)"
          type="relief"
          color="primary"
          class="mr-3"
          >Add venue</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table
        ref="table"
        class="mt-4"
        pagination
        search
        :max-items="100"
        :data="venues"
        @selected="onClicked"
      >
        <template slot="header">
          <div class="flex mb-2"></div>
          <vs-spacer />
        </template>

        <template slot="thead">
          <vs-th></vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th>City</vs-th>
          <vs-th>VAT Number</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <img width="40" :src="tr.logoUrl" />
              </vs-td>
              <vs-td>{{ tr.name }}</vs-td>
              <vs-td>{{ tr.city }}</vs-td>
              <vs-td>{{ tr.vatNumber }}</vs-td>
              <vs-td>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  @click.stop="onClickEdit(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import HandleProductSidebar from "./VenueSidebar.vue";
import popupAddVenue from "./Venue/PopupAddNewVenue.vue";

export default {
  components: {
    HandleProductSidebar,
    popupAddVenue,
  },
  data() {
    return {
      isLoading: true,
      ProductIcon,

      filters: {
        category: null,
        vendor: null,
        status: null,
      },
    };
  },
  methods: {
    onClickEdit(item) {
      this.$router.push({
        name: "pos-venue-edit",
        params: { id: item.id },
      });
    },
    onClicked(item) {
      this.$refs.productSidebar.show(item.id);
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      venues: "pos/venues/venues",
    }),
  },

  async created() {
    this.isLoading = true;
    await Promise.all([this.$store.dispatch("pos/venues/getVenues")]);
    console.log("venues", this.venues);
    this.isLoading = false;
  },
};
</script>